import { useEffect } from 'react';
import ResultsTable from './ResultsTable';
import SummaryPanel from './SummaryPanel';
import LimitBanner from '../common/LimitBanner';
import HumanReviewBanner from '../common/HumanReviewBanner';

const ResultsPage = ({ evaluationData, sourceLanguage, targetLanguage, listModels, limits }) => {
  const results = evaluationData?.segments?.map((segment, index) => ({
    id: index + 1,
    source: segment.sourceText,
    target: segment.targetText,
    score: segment.score ?? 0,
    comments: segment.comments,
    corrected: segment.correctedText,
    serverId: segment.id,
    status: segment.status,
  })) || [];

  useEffect(() => {
    localStorage.removeItem('emailSent');
  }, []);
  
  return (
    <div>
      <LimitBanner limits={limits} evaluationData={evaluationData} />
      <h1 className="text-2xl font-bold">
        Translation Quality Evaluation Results
      </h1>
      <div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6 items-start">
        <div className="w-full md:flex-grow md:min-w-0">
          <ResultsTable 
            results={results} 
            sourceLanguage={sourceLanguage}
            targetLanguage={targetLanguage}
            evaluationId={evaluationData?.id}
            limits={limits}
          />
        </div>
        <div className="w-full md:w-[276px] xl:w-80 flex-shrink-0 md:sticky md:top-[80px] z-30 space-y-6">
          <SummaryPanel 
            evaluation={evaluationData} 
            segments={evaluationData?.segments} 
            listModels={listModels} 
          />
          <HumanReviewBanner />
        </div>
      </div>
    </div>
  );
};

export default ResultsPage; 